import { CountryCode, PersonIdentityCode } from '@quromedical/fhir-common';
import type { PersonContact, PersonGeneral } from '@quromedical/models';

export const initialGeneral: Partial<PersonGeneral> = {
  identifierCode: PersonIdentityCode.saIdNumber,
  gender: undefined,
};

export const initialContact: Partial<PersonContact> = {
  telecomPhoneNumbers: ['', ''],
  addressLines: ['', ''],
  addressCountry: CountryCode.SouthAfrica,
};
